import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, MessageCircle, Bell, User, Plus } from 'lucide-react';

const items = [
  { key: 'home', path: '/', Icon: Home, label: 'Home' },
  { key: 'chats', path: '/chats', Icon: MessageCircle, label: 'Chats' },
  { key: 'create', path: null, Icon: Plus, label: '' },
  { key: 'alerts', path: '/alerts', Icon: Bell, label: 'Alerts' },
  { key: 'profile', path: '/profile', Icon: User, label: 'Profile' },
];

export default function BottomNav({ onCreate }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (p) => (p === '/' ? pathname === '/' : pathname.startsWith(p));

  return (
    <nav className="shrink-0 bg-[#0a0f18] border-t border-[#141c28] px-2 pb-1">
      <div className="flex items-center justify-around">
        {items.map((it) => {
          if (it.key === 'create') {
            return (
              <button
                key={it.key}
                onClick={onCreate}
                className="w-12 h-12 -mt-4 rounded-full bg-[#2f8bff] flex items-center justify-center shadow-lg shadow-[#2f8bff]/30 active:scale-90 transition-transform"
              >
                <Plus size={26} className="text-white" strokeWidth={2.5} />
              </button>
            );
          }
          const active = isActive(it.path);
          return (
            <button
              key={it.key}
              onClick={() => navigate(it.path)}
              className="flex flex-col items-center gap-0.5 py-2 px-3 active:scale-90 transition-transform"
            >
              <it.Icon size={22} className={active ? 'text-[#2f8bff]' : 'text-[#8b95a5]'} strokeWidth={active ? 2.4 : 2} />
              <span className={`text-[10px] ${active ? 'text-[#2f8bff] font-semibold' : 'text-[#8b95a5]'}`}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
